import React from 'react';
import { Badge, Group, Paper, SimpleGrid, Stack, Text } from '@mantine/core';
import { IconTrendingDown, IconTrendingUp, IconMinus } from '@tabler/icons-react';
import { formatMoney, formatNumber } from '../../lib/statistiquesFormat';
import classes from '../../pages/Statistiques.module.css';

function EvolutionBadge({ value }) {
  if (value == null) {
    return null;
  }

  const TrendIcon = value > 0 ? IconTrendingUp : value < 0 ? IconTrendingDown : IconMinus;
  const color = value > 0 ? 'teal' : value < 0 ? 'orange' : 'gray';

  return (
    <Badge size="sm" variant="light" color={color} leftSection={<TrendIcon size={12} />}>
      {value > 0 ? '+' : ''}
      {value}%
    </Badge>
  );
}

function YearTotalCard({ row }) {
  return (
    <Paper withBorder radius="md" p="md" className={classes.yearTotalCard}>
      <Group justify="space-between" mb="sm">
        <Text fw={700} size="lg">
          {row.year}
        </Text>
        <EvolutionBadge value={row.caEvolutionPct} />
      </Group>

      <Stack gap="sm">
        <div>
          <Text size="xs" c="dimmed" tt="uppercase" fw={600}>
            CA facturé TTC
          </Text>
          <Text size="xl" fw={700} lh={1.2}>
            {formatMoney(row.caTtc)}
          </Text>
        </div>

        <SimpleGrid cols={2} spacing="xs">
          <div>
            <Text size="xs" c="dimmed">
              Contrôles
            </Text>
            <Group gap={6} wrap="wrap">
              <Text size="sm" fw={600}>
                {formatNumber(row.nbControles)}
              </Text>
              <EvolutionBadge value={row.controlesEvolutionPct} />
            </Group>
          </div>
          <div>
            <Text size="xs" c="dimmed">
              Encaissements
            </Text>
            <Group gap={6} wrap="wrap">
              <Text size="sm" fw={600}>
                {formatMoney(row.encaissements)}
              </Text>
              <EvolutionBadge value={row.encaissementsEvolutionPct} />
            </Group>
          </div>
        </SimpleGrid>

        <Text size="xs" c="dimmed">
          {formatNumber(row.nbFactures)} facture(s) — CA HT {formatMoney(row.caHt)}
        </Text>
      </Stack>
    </Paper>
  );
}

export default function YearTotalsPanel({ totals = [], title = 'Totaux annuels' }) {
  if (!totals.length) return null;

  const orderedTotals = [...totals].sort((a, b) => Number(a.year) - Number(b.year));

  return (
    <div>
      <Text size="sm" fw={600} mb="sm">
        {title}
      </Text>
      <SimpleGrid cols={{ base: 1, sm: 2, lg: 3, xl: 4 }} spacing="md">
        {orderedTotals.map((row) => (
          <YearTotalCard key={row.year} row={row} />
        ))}
      </SimpleGrid>
    </div>
  );
}
